import Vue from 'vue'

const defaultPageSize = 10

// initial state
const state = {
  results: [],
  membersQuery: null,
  loading: false
}

// getters
const getters = {
  results: (state) => {
    return state.results
  },
  query: (state) => {
    return state.query
  },
  loading: (state) => {
    return state.loading
  }
}

const mutations = {
  reset (state) {
    state.results = []
    state.query = null
  },
  execute (state, payload) {
    state.results = payload.results
    state.folder = payload.params.folder
    state.query = payload.params.query
  },
  loadingStart (state) {
    state.loading = true
  },
  loadingEnd (state) {
    state.loading = false
  }
}

// actions
const actions = {
  reset: ({ commit }, params) => {
    commit({ type: 'reset' })
  },
  execute: ({ commit }, params) => {
    commit({ type: 'loadingStart' })
    Vue.axios.post('members', {
      q: params.query,
      page: params.page,
      size: defaultPageSize
    }).then(response => {
      commit({ type: 'execute', results: response.data.data, params: params })
    }).catch(e => {
    }).finally(() => {
      commit({ type: 'loadingEnd' })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
